export default __webpack_public_path__ + "static/media/formImage.d1cb2223.svg";